import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'sso-confirmation-popup',
})

export default class SSOConfirmationPopup extends Vue {

    // ----------------------------------------------------------------
    // Properties

    @Prop()
    private cardName: any;

    // -----------------------------------------------------------------
    // Action

    private onClose() {
        this.$emit('onClose');
    }

    private onConfirmOk() {
        this.$emit('onConfirmOk');
    }

}
